import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: "Enquiry form submissions (name, contact details, requirement) are used only to respond to your product enquiry. This page is editable by the site administrator. [ADD FULL PRIVACY POLICY]",
  },
  terms: {
    title: "Terms",
    body: "Product availability, specifications and prices are confirmed on enquiry. Content on this website is for general information. This page is editable by the site administrator. [ADD FULL TERMS]",
  },
  "404": {
    title: "Page Not Found",
    body: "The page you are looking for does not exist.",
  },
};

export default function StaticPage({ kind }) {
  const c = CONTENT[kind] || CONTENT["404"];
  return (
    <section className="bg-[#F6F7F8] py-24" data-testid={`static-${kind}`}>
      <SEO title={`${c.title} | Hari Om Trading Co.`} description={c.body.slice(0, 150)} noindex={kind === "404"} />
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <h1 className="font-heading text-4xl font-bold tracking-tight text-[#161616]">{c.title}</h1>
        <p className="mt-6 text-base leading-relaxed text-[#667085]">{c.body}</p>
        <Link to="/" data-testid="static-back-home" className="mt-8 inline-block bg-[#111111] px-6 py-3 font-heading text-[15px] font-semibold text-white hover:bg-[#F5B700] hover:text-[#111111]">
          Back to Home
        </Link>
      </div>
    </section>
  );
}
